import React, { useCallback, useEffect, useState } from "react";
import ControlledBox from "../../components/box/controlled-box";
import { Box, CircularProgress, SelectChangeEvent, Typography } from "@mui/material";
import { Button } from "../../components";
import { useSelector } from "react-redux";
import { getUid } from "../../redux/authSlice";
import { getData } from "../../utils/firebase";
import Snackbar from "../../components/snackbar/snackbar";
import UseBlockerHandler from "../../components/useBlocker";
import Selector from "../../components/select/select";
import { post } from "../../api/setting/actions";
import { useSettingsReadOnly } from "../../contexts/SettingsReadOnlyContext";

const languages = ["English", "Spanish", "French", "Arabic", "Chinese", "Portuguese"];

export default function Language() {
  const [defaultValues, setDefaultValues] = useState({ lang: "", isTranslateActive: false });
  const [lang, setLang] = useState("English");
  const [isTranslateActive, setIsTranslateActive] = useState<boolean>(false);

  const uid = useSelector(getUid);
  const readOnly = useSettingsReadOnly();
  const [notify, setNotify] = useState({ message: "", open: false, type: "" });
  const [submitLoading, setSubmitLoading] = useState<boolean>(false);
  const [blockChecker, setBlockChecker] = useState(false);

  const getLeadData = useCallback(async () => {
    getData(`dealers/${uid}/info/translatedLanguage`).then((res: any) => {
      if (res) {
        setLang(res);
        setDefaultValues((values) => ({ ...values, lang: res }));
      } else {
        setDefaultValues((values) => ({ ...values, lang: "English" }));
      }
    });
  }, [uid]);

  const getActivationData = useCallback(async () => {
    getData(`dealers/${uid}/info/isTranslateActive`).then((res: any) => {
      if (res) {
        setIsTranslateActive(res);
        setDefaultValues((values) => ({ ...values, isTranslateActive: res }));
      }
    });
  }, [uid]);

  const sendData = async () => {
    const data = { translatedLanguage: lang };
    try {
      await post(data, "/salesAgent-settingsApi/translate/language/");
      console.log("data saved.");
    } catch (error: any) {
      console.log(error);
    }
  };

  const handleSubmit = () => {
    if (submitLoading) return;
    setSubmitLoading(true);
    sendData()
      .then((res) => {
        console.log(res);
        setNotify({ message: "success", open: true, type: "" });
      })
      .catch((err) => {
        console.log(err);
        setNotify({ message: err.response?.data?.error, open: true, type: "error" });
      })
      .finally(() => {
        setSubmitLoading(false);
        getLeadData();
        getActivationData();
      });
  };

  useEffect(() => {
    getLeadData();
    getActivationData();
  }, [getActivationData, getLeadData, uid]);

  useEffect(() => {
    const isEqual =
      defaultValues.lang === lang && defaultValues.isTranslateActive === isTranslateActive;
    setBlockChecker(!isEqual);
  }, [defaultValues.isTranslateActive, defaultValues.lang, isTranslateActive, lang]);

  return (
    <>
      <ControlledBox title="Translate">
        {/* <Box
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
          sx={{ width: "fit-content", gap: "16px", marginBottom: "24px" }}
        >
          <Box>
            <Typography>Translate</Typography>
          </Box>
          <CustomizedSwitches
            name="appointmentOnly"
            checked={isTranslateActive}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setIsTranslateActive(event.target.checked);
            }}
          />
        </Box> */}
        <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          <Typography sx={{ color: "#686868", fontSize: "14px" }}>
            Configure automatic translation for customer messages and responses.
          </Typography>
          <Selector
            data={languages}
            value={lang}
            disabled={readOnly}
            onChange={(e: SelectChangeEvent) => {
              setLang(e.target.value);
            }}
            sx={{
              borderRadius: "8px",
              minWidth: "200px",
              backgroundColor: (theme: any) => theme.bg.paper,
              width: "100%",
              textAlign: "left",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          />
        </Box>
      </ControlledBox>
      {!readOnly && (
        <Box display={"flex"} justifyContent={"center"} width={"100%"} gap={1}>
          <Button variant="outlined" color="primary">
            Cancel
          </Button>
          <Button
            disabled={submitLoading}
            variant="contained"
            color="primary"
            onClick={handleSubmit}
          >
            {submitLoading ? <CircularProgress color="info" size={16} /> : "Save Changes"}
          </Button>
        </Box>
      )}
      <Snackbar
        handleClose={() => setNotify({ message: "", open: false, type: "" })}
        message={notify.message}
        open={notify.open}
        type={notify.type}
      />
      <UseBlockerHandler status={blockChecker} />
    </>
  );
}
